<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        ></v-progress-circular>
        <v-card v-if="!loading" max-width="650px">
          <v-card-title>
            <span class="headline">{{
              $t("users.serviceProvidersDetails.preview")
            }}</span>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn text color="primary" @click="edit()"
                ><v-icon small class="mx-2">mdi-pencil</v-icon>
                {{ $t("users.serviceProvidersDetails.edit") }}</v-btn
              >
              <v-btn text color="red" v-if="canUserDelete" @click="deleteFn()">
                <v-icon small class="mx-2">mdi-delete</v-icon
                >{{ $t("users.serviceProvidersDetails.delete") }}</v-btn
              >
            </v-card-actions>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0" pa-1 ma-1>
                    <v-card-title class="subtitle-1">{{
                      $t("users.serviceProvidersDetails.name")
                    }}</v-card-title>
                    <v-card-subtitle> {{ editedItem.name }}</v-card-subtitle>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{
                        $t("users.serviceProvidersDetails.manufacturerName")
                      }}
                    </v-card-title>
                    <v-card-subtitle>
                      <v-chip
                        v-bind:key="vendor.uuid"
                        v-for="vendor in editedItem.vendors"
                        class="mx-1"
                      >
                        <span>{{ vendor.name }}</span>
                      </v-chip></v-card-subtitle
                    >
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1">{{
                      $t("users.serviceProvidersDetails.category")
                    }}</v-card-title>
                    <v-card-subtitle>
                      <v-chip
                        v-bind:key="domain"
                        v-for="domain in editedItem.domains"
                        class="mx-1"
                      >
                        <span>{{ domain }}</span>
                      </v-chip></v-card-subtitle
                    >
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("users.serviceProvidersDetails.address") }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.address }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("users.serviceProvidersDetails.city") }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.city }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("users.serviceProvidersDetails.country") }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ getCountry(editedItem.country) }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("users.serviceProvidersDetails.email") }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.email }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("users.serviceProvidersDetails.website") }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.website }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="8" lg="12">
                  <v-card elevation="0">
                    <v-card-title class="subtitle-1"
                      >{{ $t("users.serviceProvidersDetails.phone") }}
                    </v-card-title>
                    <v-card-subtitle>
                      {{ editedItem.phone }}
                    </v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close" text
              >{{ $t("users.serviceProvidersDetails.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <delete-dialog
          :dialog="deleteDialog"
          :item="itemName"
          @agree="remove"
          v-show="false"
        />
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api.js";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import constants from "@/utils/constants";

export default {
  components: { DeleteDialog },
  data: () => ({
    loading: true,
    deleteDialog: false,
    canUserDelete: true,
    itemName: null,
    editedItem: {
      name: "",
      crm_group_uuid: "",
      vendor_uuids: [],
      brands: [],
      dealer: [],
      vendor: null,
      domains: [],
      address: "",
      city: "",
      country: "",
      email: "",
      website: "",
      phone: "",
    },
  }),

  created() {
    let promises = [
      api.getServiceProvider(this.$route.params.id),
      api.getServiceProviderList(),
    ];

    Promise.all(promises).then((values) => {
      this.editedItem = values[0].data;
      this.canUserDelete = values[1].data.results.length > 1;
      this.loading = false;
    });
  },
  methods: {
    getCountry(country) {
      let foundCountry = constants.countries().find((element) => {
        return element.value === country;
      });

      if (typeof foundCountry === "undefined") return country;

      return foundCountry.text;
    },
    close() {
      this.$router.push({
        name: "serviceProviders",
      });
    },
    edit() {
      this.$router.push({
        name: "serviceProviderEdit",
        params: { id: this.editedItem.uuid, tab: "info" },
      });
    },
    deleteFn() {
      this.deleteDialog = true;
      this.itemName = this.editedItem.name;
    },

    remove(agreed) {
      if (agreed) {
        api.deleteServiceProvider(this.editedItem.uuid).then((resp) => {
          this.$router.push({
            name: "serviceProviders",
          });
        });
      }
      this.deleteDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
